import * as React from 'react'
import Button from '@mui/material/Button'
import axios from 'axios'

export const PatientSimulatorPowerButton = ({ address }) => {
  const pressButton = async () => {
    await axios.get(`http://${address}:5000/patientSimulator/power`)
  }

  return <Button onClick={pressButton}>Power</Button>
}
